<template>

  <Menu theme="light" width="300" @on-select="openMenu" :open-names="['0','100']" :active-name="active" :class="menuitemClasses" accordion>
    <!--内容主页-->

    <Submenu v-show="navActiveIndex == 1" v-for="(vo,index) in areaList" :key="index" :name="index">
      <template slot="title">
        <Icon type="md-cube"></Icon>
        <span>{{vo.areaName}}</span>
        <Button v-if="vo.areaId!=0" @click="editArea(vo)"
                style=" color: #28EDF8;position: relative;margin-left:3px; top:-1px;" icon="md-create"
                title="编辑区域" size="small" ></Button>
        <Button @click="addArea()"
                style=" color: #28EDF8;position: relative;margin-left:3px;top:-1px" icon="md-add" title="添加区域"
                size="small" ></Button>
        <Button @click="delArea(vo)"
                style=" color: #28EDF8;position: relative;margin-left:3px;top:-1px" icon="md-trash" title="删除区域"
                size="small" ></Button>
      </template>
      <MenuItem v-if="vo.areaId!=0":name="'znsb_智能设备_'+vo.areaId+'_'+vo.areaName">
        <Icon type="ios-apps"></Icon>
        <span>智能设备</span>
      </MenuItem>
      <MenuItem v-if="vo.areaId!=0" :name="'zncj_智能场景_'+vo.areaId+'_'+vo.areaName">
        <Icon type="md-ionitron"></Icon>
        <span>智能场景</span>
      </MenuItem>
      <MenuItem v-if="vo.areaId!=0" :name="'sjtj_数据统计_'+vo.areaId+'_'+vo.areaName">
        <Icon type="ios-stats-outline"></Icon>
        <span>数据统计</span>
      </MenuItem>
    </Submenu>

    <Submenu v-show="navActiveIndex == 2" name="100">
      <template slot="title">
        <Icon type="md-settings"></Icon>
        <span>控制中心</span>
      </template>
      <MenuItem name="message_消息中心">
        <Icon type="ios-mail"></Icon>
        <span>消息中心</span>
      </MenuItem>
      <MenuItem name="sbbx_设备报修">
        <Icon type="ios-construct"></Icon>
        <span>设备报修</span>
      </MenuItem>
      <MenuItem name="maintain_养护管理">
        <Icon type="md-color-fill"></Icon>
        <span>养护管理</span>
      </MenuItem>
      <MenuItem name="question_常见问题">
        <Icon type="ios-copy"></Icon>
        <span>常见问题</span>
      </MenuItem>
      <MenuItem name="proposal_意见反馈">
        <Icon type="ios-create"></Icon>
        <span>意见反馈</span>
      </MenuItem>
      <MenuItem name="set_设置">
        <Icon type="ios-settings"></Icon>
        <span>设置</span>
      </MenuItem>
      <MenuItem name="manual_用户手册">
        <Icon type="ios-book" /></Icon>
        <span>用户手册</span>
      </MenuItem>
      <MenuItem name="about_关于瀚土智能">
        <Icon type="md-alert"></Icon>
        <span>关于瀚土智能</span>
      </MenuItem>
    </Submenu>

  </Menu>

</template>

<script>
    export default {
        props: ["menuitemClasses"],
        data() {
            return {
                active:'',
                //没有区域时，默认第一个，areaId:'0'时影藏其他菜单，智能设备页不显示内容
                areaList:[{areaName:'请添加区域',areaId:'0'}],
                toPath:''
            };
        },
        computed:{
            navActiveIndex(){
                return this.$store.state.app.navActiveIndex
            },
            areaId(){
                return this.$store.state.app.areaId
            },
            areaName(){
                return this.$store.state.app.areaName
            }
        },
        watch:{
            navActiveIndex(val)
            {
                let that = this,_active,_path,_title;
                if(val === 1  && that.areaList.length > 0){
                    var vo = that.areaList[0];
                    _title = "智能设备";
                    _active = 'znsb_智能设备_'+vo.areaId+'_'+vo.areaName;
                    _path = '/znsb';
                }
                if(val === 2){
                    _title = "消息中心";
                    _active = 'message_消息中心';
                    _path = '/message';
                }
                that.active = _active;
                if(that.$store.state.app.routeTo.path === _path){
                    that.$store.commit('setBreadCrumb',{
                        path : _path,
                        name : _active,
                        title: _title
                    })
                }
            },

        },
        created(){
            var that = this;
            that.getData();
        },
        methods: {
            getData(){
                var that = this;
                that.$func.ajax('listArea',{
                    token:that.$func.getToken(),
                },function(r){
                    if(!r.statusCode){
                        that.$func.msg(r.message,'error');
                    }else
                    {
                        if(r.type.length>0){
                            that.areaList=r.type;
                            //全局记录areaId
                            let setAreaId;
                            setAreaId = {
                                areaId:that.areaList[0].areaId,
                                areaName: that.areaList[0].areaName
                            };
                            that.$store.commit('setAreaId',setAreaId);
                            that.menuList();
                        }

                    }
                })
            },
            //添加区域
            addArea(){
                const that = this;
                var newVal = '';
                that.$Modal.confirm({
                    title: '添加区域',
                    render: (h) => {
                        return h('div', [
                            h('div', [
                                h('div', {
                                    style: {
                                        marginTop: '.2rem'
                                    },
                                }, [
                                    h('label', '区域名称：', {
                                        style: {
                                            width: '20%',
                                            marginRight: '.3rem'
                                        },
                                    }),
                                    h('Input', {
                                        style: {
                                            width: '80%'
                                        },
                                        props: {
                                            value: '',
                                            autofocus: true,
                                            placeholder: '请输入区域名称',
                                            maxlength: 10
                                        },
                                        on: {
                                            input: (val) => {
                                                newVal = val;
                                            }
                                        }
                                    })
                                ]),
                            ])
                        ])
                    },
                    onOk: () => {
                        if (newVal == '') {
                            this.$Message.error('区域名称不能为空');
                            return
                        }
                        that.$func.ajax('saveArea', {
                            areaName:newVal,
                        }, function (r) {
                            if (!r.statusCode) {
                                that.$func.msg(r.message, 'error');
                            } else {
                                that.$Message.success('添加成功');
                                that.getData();
                            }
                        })
                    }
                })
            },
            //删除区域
            delArea(item){
                const that = this;
                that.$Modal.confirm({
                    title: '确定删除该区域吗？',
                    content: '将会把该区域下的所有设备、场景删除，请您知晓！',
                    onOk: () => {
                        that.$func.ajax('delArea', {
                            areaId:item.areaId
                        }, function (r) {
                            if (!r.statusCode) {
                                that.$func.msg(r.message, 'error');
                            } else {
                                that.$Message.success('删除成功');
                                that.getData();
                            }
                        })
                    }
                })
            },
            //编辑区域
            editArea(item){
                const that = this;
                var newVal = '';
                that.$Modal.confirm({
                    title: '编辑区域',
                    render: (h) => {
                        return h('Input', {
                            props: {
                                value: item.areaName,
                                autofocus: true,
                                placeholder: '请输入区域名称',
                                maxlength: 10
                            },
                            on: {
                                input: (val) => {
                                    newVal = val
                                }
                            }
                        })
                    },
                    onOk: () => {
                        if (newVal == '') {
                            this.$Message.error('区域名称不能为空');
                            return
                        }
                        that.$func.ajax('saveArea', {
                            areaName:newVal,
                            areaId:item.areaId
                        }, function (r) {
                            if (!r.statusCode) {
                                that.$func.msg(r.message, 'error');
                            } else {
                                that.$Message.success('修改成功');
                                that.getData();
                            }
                        })
                    }
                })
            },

            openMenu(name)
            {
                let path,title;
                if(name.split('_').length > 2)
                {   //全局记录areaId
                    let setAreaId;
                    setAreaId = {
                        areaId:name.split('_')[2],
                        areaName: name.split('_')[3]
                    };
                    this.$store.commit('setAreaId',setAreaId);
                    path  = name.split('_')[0];
                    title = name.split('_')[3]+' /  '+name.split('_')[1];
                }else{
                    path  = name.split('_')[0];
                    title = name.split('_')[1];
                }
                //跳转
                this.$router.push({ name: path});
                //发送
                this.$store.commit('setBreadCrumb',{
                    path : '/'+path,
                    name : path,
                    title: title
                })
            },
            menuList() // 这个方法里定义好，高亮和路由
            {
                let that = this;
                let path = that.$store.state.app.routeTo.path  // 获取到地址拦上#号后面的url地址
                let h1 = ['/zncj','/znsb','/sjtj'];
                let h2 = ['/message','/sbbx','/maintain','/question','/proposal','/set','/manual','/about'];
                //判断
                var title;
                switch (path) {
                    case '/zncj'    : title  = that.$store.state.app.areaName+'/ 智能场景';break;
                    case '/znsb'    : title  = that.$store.state.app.areaName+'/ 智能设备';break;
                    case '/sjtj'    : title  = that.$store.state.app.areaName+'/ 数据统计';break;
                    case '/message' : title  = '消息中心';break;
                    case '/sbbx'    : title  = '设备报修';break;
                    case '/maintain'    : title  = '养护管理';break;
                    case '/question': title  = '常见问题';break;
                    case '/proposal': title  = '意见反馈';break;
                    case '/set'     : title  = '设置';break;
                    case '/manual'   : title  = '用户手册';break;
                    case '/about'   : title  = '关于瀚土智能';break;
                }

                if(h1.indexOf(path) != -1){
                    that.$store.commit("setNavActiveIndex",1);
                    that.$nextTick(function () {
                        that.active =  path.split('/')[1]+'_'+title;;
                    });
                }
                if(h2.indexOf(path) != -1){
                    that.$store.commit("setNavActiveIndex",2);
                    that.$nextTick(function () {
                        that.active = path.split('/')[1]+'_'+title;
                    });
                }
                that.$store.commit('setBreadCrumb',{
                    path : path,
                    name : that.active,
                    title: title
                })
            }
        },
        mounted(){  // 组件初始化后执行

        }
    };
</script>

<style scoped>
</style>
